module.exports = __webpack_public_path__ + "img/menu_icon15.70e1df9f.png";